import { Vue, Component } from 'vue-property-decorator';
import ChangesSaved from '@/features/settings/components/ChangesSaved.vue';
import { InProgress, ShipFrom, ShipTo } from '@/features/shipment/types';
import { UserPreferences } from '@/features/settings/types';

@Component({
  components: {
    ChangesSaved,
  },
})
export class PreferencesMixin extends Vue {
  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  public isUserWorkingOnShipment(fromAddressPref: ShipFrom): boolean {
    const {
      toAddress,
      fromAddress,
    } = this.$store.getters.getInProgress;

    const toAddressWithoutChange = Object.values(toAddress as ShipTo).every(
      (x) => x === null || x === '' || x === undefined || x === false || x.length === 0,
    );

    const fromAddressWithoutChange = Object.entries(fromAddress).every(
      ([key, value]) => {
        if (fromAddressPref) {
          return fromAddress[key] === value;
        }

        return false;
      },
    );

    return !toAddressWithoutChange || !fromAddressWithoutChange;
  }

  public patchPreferenceInStore(path: string, value: unknown): void {
    const keys = path.split('/');
    const inProgress: InProgress = this.$store.getters.getInProgress;

    if (['shippingSettings', 'customsSettings'].includes(keys[0])) {
      let inProgressValue = value;
      let keyName = keys[1];

      switch (keyName) {
        case 'defaultAddress':
          keyName = 'fromAddress';
          if (keys.length === 3) {
            inProgressValue = {
              ...inProgress.fromAddress,
              [keys[2]]: value,
            };
          } else if (this.isUserWorkingOnShipment(value as ShipFrom)) {
            inProgressValue = null;
          }
          break;
        case 'signatureOption':
          keyName = 'signatureOptions';
          this.updateEstimateData(keyName, inProgressValue);
          break;
        case 'reference':
          keyName = 'references';
          inProgressValue = [inProgressValue];
          break;
        case 'weightUnits':
        case 'dimUnits':
        case 'packageType':
          keyName = `temporaryPackage/${keyName}`;
          break;
        case 'reasonForExport':
        case 'currencyCode':
          keyName = `commercialInvoice/${keyName}`;
          break;
        default:
          break;
      }

      if (inProgressValue !== null) {
        this.$store.commit('patchInProgress', { key: keyName, value: inProgressValue });
      }
    }

    this.$store.commit('patchUserPreferences', {
      key: path,
      value,
    });
  }

  private updateEstimateData(key: string, value: unknown) {
    this.$store.commit('patchEstimateData', {
      key,
      value,
    });
  }
}
